module.exports = __webpack_public_path__ + "static/Laptop1_Mobile-ae78b5f8f40a26e5c2fbec68dcf89ef9.mp4";